<template>
  <div class="wrap-news-detail">
    <b-container>
      <b-row
        class="box-head"
      >
        <b-col
          cols="12"
          md="8"
          class="box-breadcrumb"
        >
          <b-breadcrumb :items="breadcrumbs" />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="box-back-btn"
        >
          <button @click.prevent="goBack()">
            Back to News
          </button>
        </b-col>
      </b-row>

      <div
        v-for="detail in newsDetailRaw"
        :key="detail.id"
        class="box-content"
      >
        <!-- <h1>{{ detail.name }}</h1>
        <p>{{ detail.publish_datetime }}</p> -->
        <span v-html="detail.content"></span>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'News & Activities',
          to: {
            name: 'home'
          }
        },
        {
          text: ''
        }
      ]
    }
  },

  computed: {
    ...mapState({
      newsDetailRaw: state => state.news.newsDetail
    })
  },

  methods: {
    goBack () {
      this.$router.go(-1)
    },

    matchBreadcrumb (data) {
      data.forEach(item => {
        this.breadcrumbs[2].text = item.name
      })
    }
  },

  created () {
    this.$store.dispatch('news/getDetail', this.$route.params.id)
  },

  watch: {
    newsDetailRaw (data) {
      this.matchBreadcrumb(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-news-detail {
  .container {
    .box-head {
      padding: 22px 0;
      border-bottom: 1px solid #CCC;

      .box-breadcrumb {
        display: flex;
        align-items: center;

        .breadcrumb {
          margin: 0;
          padding: 0;
          background: none;

          li {
            font-size: 1.25rem;

            a {
              color: black;
            }
          }
        }
      }

      .box-back-btn {
        margin-top: 22px;

        @media only screen and (min-width: $break-m) {
          margin-top: 0;
        }

        button {
          width: 100%;
          background-color: #CCC;
          padding: 12px 0;
          font-size: 1.25rem;
        }
      }
    }

    .box-content {
      padding: 22px 0;

      h1 {
        font-size: 2rem;
      }

      p {
        margin-bottom: 22px;
        font-size: 1.25rem;
      }

      span {
        font-size: 1.25rem;
      }

    }
  }
}
</style>
